import { type Configuration } from '@azure/msal-browser';

/**
 * MSAL 환경변수 4개 모두 설정된 경우에만 true 반환.
 * 순수 boolean 판별 함수 — 예외를 던지지 않음.
 */
export function isMsalConfigured(): boolean {
  return !!(
    import.meta.env.VITE_MSAL_CLIENT_ID &&
    import.meta.env.VITE_MSAL_AUTHORITY &&
    import.meta.env.VITE_MSAL_REDIRECT_URI &&
    import.meta.env.VITE_MSAL_SCOPE
  );
}

/**
 * 환경변수가 1~3개만 설정된 경우(부분 설정) 에러 메시지 반환.
 * 0개(미설정) 또는 4개(정상 설정)이면 null 반환.
 */
export function getMsalConfigError(): string | null {
  const hasClientId = !!import.meta.env.VITE_MSAL_CLIENT_ID;
  const hasAuthority = !!import.meta.env.VITE_MSAL_AUTHORITY;
  const hasRedirectUri = !!import.meta.env.VITE_MSAL_REDIRECT_URI;
  const hasScope = !!import.meta.env.VITE_MSAL_SCOPE;

  const count = [hasClientId, hasAuthority, hasRedirectUri, hasScope].filter(Boolean).length;
  if (count === 0 || count === 4) return null;

  const missing: string[] = [];
  if (!hasClientId) missing.push('VITE_MSAL_CLIENT_ID');
  if (!hasAuthority) missing.push('VITE_MSAL_AUTHORITY');
  if (!hasRedirectUri) missing.push('VITE_MSAL_REDIRECT_URI');
  if (!hasScope) missing.push('VITE_MSAL_SCOPE');

  return `MSAL 설정 오류: 다음 환경변수가 누락되었습니다: ${missing.join(', ')}`;
}

export function getMsalConfig(): Configuration {
  return {
    auth: {
      clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
      authority: import.meta.env.VITE_MSAL_AUTHORITY,
      redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  };
}

export const loginRequest = {
  scopes: [import.meta.env.VITE_MSAL_SCOPE],
};
